import { render } from "./EmailCustomTemplateModal.vue?vue&type=template&id=5b0740f2&scoped=true"
import script from "./EmailCustomTemplateModal.vue?vue&type=script&lang=js"
export * from "./EmailCustomTemplateModal.vue?vue&type=script&lang=js"

import "./EmailCustomTemplateModal.vue?vue&type=style&index=0&id=5b0740f2&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b0740f2"]])

export default __exports__